import React from 'react';
import PropTypes from 'prop-types';
import './entity-list.css';

/**
 * Page shell for the entity-list pattern (see docs/ui/entity-list-pattern.md).
 * Owns all outer page padding/geometry — children (PageHead, ListToolbar,
 * DataTable, Paginator) sit flush inside it.
 *
 * Renders a <div>, not a <main> — App.js:176 already renders the app's one
 * <main>, and a second nested one would double up App.css's `main { margin-top:
 * 80px }`. The `entity-list-page` class is a stable hook for the small set of
 * unlayered-CSS escape hatches in entity-list.css.
 */
function EntityList({ density, children }) {
	return (
		<div
			className='entity-list-page tw:mx-auto tw:max-w-[1440px] tw:px-8 tw:pt-6 tw:pb-24 tw:font-sans tw:text-[14px]/[1.45] tw:text-ink-0'
			data-density={density}
		>
			{children}
		</div>
	);
}

EntityList.propTypes = {
	density: PropTypes.oneOf(['compact', 'spacious']),
	children: PropTypes.node,
};

export default EntityList;
